module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTI4IiBoZWlnaHQ9IjEyOCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMCA1NC44NTdoNTQuNzk2djE4LjI4NkgzNi41MzFWMTI4SDE4LjI2NVY3My4xNDNIMFY1NC44NTd6bTEyNy44NTctMzYuNTcxSDkxLjkzNVYxMjhINzIuNDU2VjE4LjI4NkgzNi41MzRWMGg5MS4zMjZsLS4wMDMgMTguMjg2eiIvPjwvc3ZnPg=="


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/size.svg
// module id = Cr4N
// module chunks = 51